import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'
import { fetchSets, addSets, sortSets, searchSets } from "../../actions/settings"
import SetsPercItem from "./SetsPercItem"
import Select from 'react-select'
import SettingsForm from './SettingsForm'

class SetsPerc extends SettingsForm {

  modelName = 'perc'

  newItem = {
    perc_desc: '',
    perc_perc: 0,
    perc_type: 1,
    perc_text: '',
    perc_active: 1
  }

  render() {
    if(isEmpty(this.props.percs.data)
    ){
      return(<div>Не загружены данные</div>);
    }
    const percs = this.props.percs.data;
    const { search, sort } = this.props.percs;
    const { data, errors } = this.state;

    var fltrPercs = [];
    for(var key in percs){
      if(percs.hasOwnProperty(key)){
        const active = percs[key].perc_active === 1;
        var found = true;
        if(search !== ''){
          const searchValue = "" + percs[key].perc_desc + percs[key].perc_text;
          found = searchValue.toLowerCase().indexOf(search) !== -1;
        }
        if(active && found){
          fltrPercs.push(percs[key]);
        }
      }
    }

    const srtPercs = fltrPercs.sort( (a, b) => {
      if(a[sort.field] < b[sort.field])
         return sort.asc ? -1 : 1
      if(a[sort.field] > b[sort.field])
         return sort.asc ? 1 : -1
      if(a.perc_id < b.perc_id)
         return sort.asc ? -1 : 1
      if(a.perc_id > b.perc_id)
         return sort.asc ? 1 : -1
      return 0
    });

    const mappedPercs = srtPercs ? srtPercs.map(perc =>
      <SetsPercItem key={perc.perc_id}
        data={perc}
      />
    ) : [];

    const addNew = this.state.adding ?
      <tr>
        <td>
          <div className="form-group">
            <input type="text"
              className="form-control"
              value={data.perc_desc}
              name="perc_desc"
              onChange={this.updateInput}
              placeholder="Название"
              autoFocus
            />
          </div>
          <div className="form-inline">
            <button  type="button" className="btn btn-success"
              onClick={this.saveItem} title="Сохранить">
              <span className="glyphicon glyphicon-save"></span>
            </button>{" "}
            <button type="button" className="btn btn-default"
              onClick={this.cancelAdding} title="Отменить">
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td>
          <input type="text"
            className="form-control"
            value={data.perc_perc}
            name="perc_perc"
            onChange={this.updateInput}
            placeholder="Процент"
          />
        </td>
        <td>
          <Select
            clearable={false}
            options={[{value:1,label:'Надбавка'},{value:-1,label:'Скидка'}]}
            value={data.perc_type}
            onChange={e => this.updateSelect(e,'perc_type')}
            title="Тип корректировки"
          />
        </td>
        <td>
          <input type="text"
            className="form-control"
            value={data.perc_text}
            name="perc_text"
            onChange={this.updateInput}
            placeholder="Описание"
          />
        </td>
      </tr>
      :[];


    return (
      <div>
        <h3 className="pull-right">Настройка скидок/надбавок</h3>
        <div className="form-group form-inline">
          <button className="btn btn-primary" onClick={this.startAdding}>Создать</button>
          {" "}
          <div className="input-group">
            <input
              type="search"
              className="form-control"
              value={search}
              title="Поиск"
              placeholder="Поиск"
              onChange={this.handleSearch} />
            <div className="input-group-btn">
              <button
                type="button"
                className="btn btn-default"
                onClick={this.clearSearch}
                title="Очистить поиск">
                X
              </button>
            </div>
          </div>{" "}
          <div className="input-group">{fltrPercs.length} записей</div>
        </div>
        <table className="table table-striped table-hover sticky-50">
          <thead>
            <tr style={{cursor:'pointer'}}>
              <th className="col-sm-3" onClick={() => {this.handleSort('perc_desc')}}>Название</th>
              <th className="col-sm-1" onClick={() => {this.handleSort('perc_perc')}}>Процент</th>
              <th className="col-sm-2" onClick={() => {this.handleSort('perc_type')}}>Тип корректировки</th>
              <th className="col-sm-6" onClick={() => {this.handleSort('perc_text')}}>Описание</th>
            </tr>
          </thead>
          <tbody>
            {addNew}
            {mappedPercs}
            <tr onClick={this.startAdding}>
              <td><u>Нажмите, чтобы добавить запись</u></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    )

  }
}

function mapOrdersToProps(store) {
  return {
    percs: store.percs
  }
}

export default connect(mapOrdersToProps, { fetchSets, addSets, sortSets, searchSets })(SetsPerc);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPerc.js